// Number of results per page
export const NUMBER_RESULTS_TO_RENDER_FOR_SEARCH_INITIAL_LOAD = 20;
export const NUMBER_RESULTS_TO_RENDER_FOR_PRO_RESEARCH_INITIAL_LOAD = 50;

// env
export const WEB_URL = process.env.NEXT_PUBLIC_WEBSITE_URL;
export const IS_PRODUCTION_ENV = process.env.DEPLOYMENT_ENV === "production";
export const IS_DEVELOPMENT_ENV = process.env.NODE_ENV === "development";
export const MIXPANEL_PROXY_API_HOST = "https://track.consensus.app";
export const CHURNKEY_APP_ID = process.env.NEXT_PUBLIC_CHURNKEY_APP_ID;
export const CHURNKEY_API_KEY = process.env.CHURNKEY_API_KEY;

// email addresses
export const SUPPORT_EMAIL = "support@consensus.app";
export const SALES_EMAIL = "sales@consensus.app";
export const STUDENT_EMAIL = "student@consensus.app";

// social
export const CRUNCHBASE_URL =
  "https://www.crunchbase.com/organization/consensus-c075";
export const INSTAGRAM_URL = "https://www.instagram.com/consensusnlp/";
export const LINKEDIN_URL = "https://www.linkedin.com/company/consensus-nlp/";
export const SLACK_URL =
  "https://join.slack.com/t/consensus-users/shared_invite/zt-2msu2l0dz-DsJaU5R651fcVjzr2_WgrQ";
export const TIKTOK_URL = "https://www.tiktok.com/@consensus_nlp";
export const TWITTER_URL = "https://twitter.com/ConsensusNLP";

// urls
export const API_DOCS_URL = "https://docs.consensus.app";
export const CAREERS_URL = "https://consensus.app/home/careers/";
export const CONTACT_US_URL = "https://consensus.app/home/contact/";
export const DOI_URL = "http://dx.doi.org";
export const EXAMPLE_SEARCH_URL =
  WEB_URL + "/results/?q=Does remote patient monitoring improve outcomes?";
export const EXAMPLE_SEARCH_URL_2 =
  WEB_URL + "/results/?q=can magnesium help sleep?";
export const GPT_URL = "https://chat.openai.com/g/g-bo0FiWLY7-consensus";
export const HOME_PAGE_URL = WEB_URL + "/?home=true";
export const INFLUENTIAL_CITATIONS_URL =
  "https://www.semanticscholar.org/faq?utm_source=consensus#influential-citations";
export const OPEN_AI_STATUS_URL = "https://status.openai.com";

// help center urls
export const HELP_CENTER_URL = "https://help.consensus.app";
export const HELP_CENTER_ARTICLE_URL = HELP_CENTER_URL + "/en/articles/";
export const HIERARCHY_OF_EVIDENCE_URL =
  HELP_CENTER_ARTICLE_URL +
  "10262689-the-hierarchy-of-evidence-a-guide-to-understanding-research-quality";
export const RCT_URL =
  HELP_CENTER_ARTICLE_URL + "10236424-randomized-control-trial-rct";
export const SYSTEMATIC_REVIEW_URL =
  HELP_CENTER_ARTICLE_URL + "10207324-systematic-review";
export const META_ANALYSIS_URL =
  HELP_CENTER_ARTICLE_URL + "10151037-meta-analysis";
export const LITERATURE_REVIEW_URL =
  HELP_CENTER_ARTICLE_URL + "10237479-literature-review";
export const OBSERVATIONAL_STUDY_URL =
  HELP_CENTER_ARTICLE_URL + "10237456-observational-study";
export const NON_RCT_URL =
  HELP_CENTER_ARTICLE_URL + "10237297-non-randomized-controlled-trial-non-rct";
export const IN_VITRO_STUDY_URL =
  HELP_CENTER_ARTICLE_URL + "10237493-in-vitro-study";
export const ANIMAL_STUDY_URL =
  HELP_CENTER_ARTICLE_URL + "10237485-animal-study";
export const CASE_REPORT_URL = HELP_CENTER_ARTICLE_URL + "10237480-case-report";
export const CONSENSUS_METER_URL =
  HELP_CENTER_ARTICLE_URL + "10069920-understanding-the-consensus-meter";

// website
export const ABOUT_URL = "https://consensus.app/home/about-us/";
export const FOR_DOCTORS_URL = "https://consensus.app/home/doctors/";
export const FOR_UNIVERSITIES_URL =
  "https://consensus.app/home/universities-student/";
export const FOR_ORGANIZATIONS_URL =
  "https://consensus.app/home/research-organizations/";
export const BLOG_URL = WEB_URL + "/home/blog";
export const METER_INDICATORS_BLOG_URL = BLOG_URL + "/consensus-meter/";
export const API_LEARN_MORE_BLOG_URL = WEB_URL + "/home/api/";

// keys
export const GLEAP_API_KEY = process.env.NEXT_PUBLIC_GLEAP_API_KEY;
export const MIXPANEL_API_KEY = process.env.NEXT_PUBLIC_MIXPANEL_API_KEY;
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;
export const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID;
export const INTERCOM_API_BASE = process.env.NEXT_PUBLIC_INTERCOM_API_BASE;
export const INTERCOM_API_IDENTITY_VERIFICATION_SECRET =
  process.env.NEXT_PUBLIC_INTERCOM_API_IDENTITY_VERIFICATION_SECRET;
export const STATSIG_CLIENT_API_KEY =
  process.env.NEXT_PUBLIC_STATSTIG_CLIENT_API_KEY;
export const STATSIG_SERVER_API_KEY = process.env.STATSIG_SERVER_API_KEY;
export const PARTNERSTACK_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_PARTNERSTACK_PUBLIC_KEY;

// meta
export const META_IMAGE = WEB_URL + "/images/consensus-card.png";
export const META_IMAGE_ALT = "An image of the Consensus logo";
export const META_TWITTER_SITE = "@ConsensusNLP";
export const META_RESULTS_IMAGE = WEB_URL + "/images/og-results.png";
export const META_DEFAULT_IMAGE = WEB_URL + "/images/og-default.png";
export const META_SEARCH_IMAGE = META_DEFAULT_IMAGE;
export const META_DETAILS_IMAGE = META_DEFAULT_IMAGE;
export const META_PRICING_IMAGE = META_DEFAULT_IMAGE;
export const META_THREADS_DYNAMIC_IMAGE = WEB_URL + "/api/og/threads";
export const META_PAPER_DETAILS_DYNAMIC_IMAGE = WEB_URL + "/api/og/papers";
export const META_QUESTIONS_PAGE_DYNAMIC_IMAGE = WEB_URL + "/api/og/questions";

// hubspot
export const HUBSPOT_WEBOOK_URL =
  "https://api-na1.hubapi.com/automation/v4/webhook-triggers/47141966/zpYtdAv";

export const MAX_MOBILE_WIDTH = 800; // Same as our mobile breakpoint used in tailwind.config.js
export const SEARCH_ITEM = "search";
export const MAX_VISIBLE_AUTHORS = 3;

// Stripe Meta Data
export const STRIPE_PRICE_METADATA_TYPE_PREMIUM = "premium";
export const STRIPE_PRICE_METADATA_TYPE_TEAM = "team";
export const STRIPE_PRICE_METADATA_TYPE_DEEP = "deep";
export const STRIPE_PRICE_METADATA_TYPE_LIFETIME = "lifetime";
export const STRIPE_PRICE_METADATA_TYPE_EARLY_BIRD = "early bird";
export const STRIPE_PRICE_METADATA_TYPE_API = "api";

// Datadog
export const DATADOG_RUM_APPLICATION_ID =
  process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID;
export const DATADOG_RUM_CLIENT_TOKEN =
  process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN;
export const DATADOG_RUM_SERVICE = process.env.NEXT_PUBLIC_DATADOG_RUM_SERVICE;
export const RELEASE_TAG = process.env.NEXT_PUBLIC_RELEASE_TAG;

export const ALLOWED_ORG_DOMAINS_AND_FULL_ORG_NAME: { [key: string]: string } =
  {
    "consensus.app": "Consensus App",
    "acu.edu": "Abilene Christian University",
    "atu.edu": "Arkansas Tech University",
    "bc.edu": "Boston College",
    "bentley.edu": "Bentley University",
    "falcon.bentley.edu": "Bentley University",
    "virginia.edu": "Univeristy of Virginia",
    "hkbu.edu.hk": "Hong Kong Baptist University",
    "northeastern.edu": "Northeastern University",
    "neu.edu": "Northeastern University",
    "vt.edu": "Virginia Tech",
    "drew.edu": "Drew University",
    "cesa.edu.co": "CESA",
    "gmu.edu": "George Mason University",
    "gonzaga.edu": "Gonzaga University",
    "zagmail.gonzaga.edu": "Gonzaga University",
    "lawschool.gonzaga.edu": "Gonzaga University",
    "harvard.edu": "Harvard University",
    "hku.edu": "Hong Kong University",
    "mit.edu": "MIT",
    "nas.edu": "National Academies",
    "nae.edu": "National Academies",
    "mahidol.ac.th": "Mahidol University",
    "student.mahidol.edu": "Mahidol University",
    "nbu.bg": "New Bulgarian University",
    "und.edu": "North Dakota University",
    "undeerc.org": "North Dakota University",
    "ohio.edu": "Ohio University",
    "ohsu.edu": "Oregon Health Science University",
    "hksyu.edu": "Hong Kong Shue Yan University",
    "hksyu.edu.hk": "Hong Kong Shue Yan University",
    "polyu.edu.hk": "Hong Kong Polytechnic University",
    "connect.polyu.hk": "Hong Kong Polytechnic University",
    "lmu.edu.ng": "Landmark University",
    "landmarkuniversity.edu.ng": "Landmark University",
    "unilu.ch": "Luzern University",
    "doz.unilu.ch": "Luzern University",
    "stud.unilu.ch": "Luzern University",
    "zhbluzern.ch": "Luzern University",
    "phlu.ch": "Luzern University",
    "stud.phlu.ch": "Luzern University",
    "phzg.ch": "Luzern University",
    "stud.phzg.ch": "Luzern University",
    "phsz.ch": "Luzern University",
    "stud.phsz.ch": "Luzern University",
    "hslu.ch": "Luzern University (Applied Sciences and Arts)",
    "stud.hslu.ch": "Luzern University (Applied Sciences and Arts)",
    "unibas.ch": "University of Basel",
    "stud.unibas.ch": "University of Basel",
    "unipv.it": "University of Pavia",
    "fielding.edu": "Fielding Graduate University",
    "mail.smu.edu": "SMU",
    "smu.edu": "SMU",
    "uleth.ca": "University of Lethbridge",
    "mcmaster.ca": "McMaster University",
    "stthomas.edu": "St. Thomas University",
    "ku.edu": "University of Kansas",
    "stkate.edu": "St. Katherine",
    "sfsu.edu": "San Francisco State University",
    "sjsu.edu": "San Jose State University",
    "stanford.edu": "Stanford University",
    "bibl.ulaval.ca": "Laval University",
    "ulaval.ca": "Laval University",
    "cegep-lanaudiere.qc.ca": "Cegep Lanaudiere",
    "ethz.ch": "ETH Zurich",
    "library.ethz.ch": "ETH Zurich",
    "umich.edu": "University of Michigan",
    "umflint.edu": "University of Michigan Flint Campus",
    "umdearborn.edu": "University of Michigan Dearborn Campus",
    "med.umich.edu": "University of Michigan Medical Center",
    "csuci.edu": "California State University, Channel Islands",
    "brescia.edu": "Brescia University",
    "tamu.edu": "Texas A&M",
    "mailbox.sc.edu": "University of South Carolina",
    "sc.edu": "University of South Carolina",
    ".sc.edu": "University of South Carolina",
    ".ecu.edu": "East Carolina University",
    "tedu.edu.tr": "TED University",
    "unb.ca": "University of New Brunswick",
    "ecu.edu": "East Carolina University",
    "jmu.edu": "James Madison University",
    "dukes.jmu.edu": "James Madison University",
    "une.edu": "University of New England",
    "universitadipavia.it": "University of Pavia",
    "utoronto.ca": "University of Toronto",
    "umontreal.ca": "University of Montreal",
    "jhu.edu": "Johns Hopkins University",
    "upenn.edu": "University of Pennsylvania",
    "wisc.edu": "University of Wisconsin",
    "nyu.edu": "New York University",
    "osu.edu": "Ohio State University",
    "ufl.edu": "University of Florida",
    "gatech.edu": "Georgia Institute of Technology",
    "utexas.edu": "University of Texas at Austin",
    "berkeley.edu": "University of California, Berkeley",
    "ucla.edu": "University of California, Los Angeles",
    "ucsf.edu": "University of California, San Francisco",
    "ucsc.edu": "University of California, Santa Cruz",
    "usc.edu": "University of Southern California",
  };

export const TEST_USER_EMAIL_REGEX_AND_ORG_NAME = {
  regex: /^consensus(\+.+)?@usemomentic\.com$/,
  orgName: "Momentic Test Users",
};

export const ALLOWED_API_ORG_IDS = [];

export const CONSENSUS_ADMIN_ORG_SLUG = "consensus-admin";

// Discounts
// Additional domains that are considered student domains, Mainly Canadian Universities
// but can be used for other countries as well.
export const NON_REGULAR_STUDENT_DOMAINS = [
  "utoronto.ca",
  "ubc.ca",
  "mcgill.ca",
  "ualberta.ca",
  "umontreal.ca",
  "mcmaster.ca",
  "uwaterloo.ca",
  "uwo.ca",
  "queensu.ca",
  "ucalgary.ca",
  "sfu.ca",
  "dal.ca",
  "ulaval.ca",
  "uottawa.ca",
  "umanitoba.ca",
  "yorku.ca",
  "carleton.ca",
  "uvic.ca",
  "concordia.ca",
  "torontomu.ca",
];
export const STUDENT_EMAIL_DOMAINS = ["edu", "ac", "student"];
export const STUDENT_DISCOUNT_1_YEAR = "wjkc1OXY";
export const STUDENT_DISCOUNT_2_YEAR = "1GINMYoW";
export const STUDENT_DISCOUNT_3_YEAR = "VwIlgtN0";
export const STUDENT_DISCOUNT_4_YEAR = "gjKtbhze";
export const STUDENT_DISCOUNT_1_YEAR_PERCENT = 40;
export const STUDENT_DISCOUNT_2_YEAR_PERCENT = 40;
export const STUDENT_DISCOUNT_3_YEAR_PERCENT = 40;
export const STUDENT_DISCOUNT_4_YEAR_PERCENT = 40;
export const STUDENT_TRIAL_PERIOD_DAYS = 365;
export const GRAD_STUDENT_TRIAL_PERIOD_DAYS = 30;
export const STUDENT_DISCOUNT_PERCENT = 40;

export const ANNUAL_PRICE_DISCOUNT = "33%";
export const ANNUAL_PRICE_DISCOUNT_VALUE = (11.99 - 8.99) / 8.99;

// Mailchimp
export const MAILCHIMP_TAG = "Product_Activation";

// Bookmark
export const BOOKMARK_LISTNAME_FAVORITE = "My favorites";
export const BOOKMARK_LISTNAME_MAX_LENGTH = 100;

export const PRIVACY_PAGE_URL = BLOG_URL + "/privacy-policy/";
export const TERMS_PAGE_URL = BLOG_URL + "/terms-of-service/";
export const EXAMPLE_QUERY = "Does beta alanine improve exercise performance?";

// Number of ms for how long it takes to display the confirmation message after click copy.
export const COPY_TIMEOUT_MILLISECONDS = 3000;

// Credit usage
export const MAX_CREDIT_NUM = 20;
export const CREDIT_RESET_INTERVAL_DAYS = 30;
export const MAX_CREDIT_NUM_PREMIUM = 200;
export const MIN_TEAM_SEATS_COUNT = 2;
export const MAX_TEAM_SEATS_COUNT = 200;
export const ASK_PAPER_CREDITS_PER_MONTH_ANONYMOUS_USER = 1;
export const ASK_PAPER_CREDITS_PER_MONTH_FREE_USER = 10;
export const PRO_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER = 3;
export const PRO_SEARCH_CREDITS_PER_MONTH_FREE_USER = 25;
export const PRO_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER = null; // Unlimited
export const QUICK_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER = 0;
export const QUICK_SEARCH_CREDITS_PER_MONTH_FREE_USER = null; // Unlimited
export const QUICK_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER = null; // Unlimited
export const DEEP_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER = 0;
export const DEEP_SEARCH_CREDITS_PER_MONTH_FREE_USER = 3;
export const DEEP_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER = 15; // Updated from 100
export const DEEP_SEARCH_CREDITS_PER_MONTH_DEEP_USER = 200; // Deep tier
export const DEEP_SEARCH_CREDITS_PER_MONTH_TEAM_USER = 50; // Team tier
export const DEEP_SEARCH_CREDITS_PER_MONTH_ENTERPRISE_USER = 50; // Enterprise tier

// Deep tier credit limits
export const ASK_PAPER_CREDITS_PER_MONTH_DEEP_USER = null; // Unlimited
export const PRO_SEARCH_CREDITS_PER_MONTH_DEEP_USER = null; // Unlimited
export const QUICK_SEARCH_CREDITS_PER_MONTH_DEEP_USER = null; // Unlimited
export const SNAPSHOT_CREDITS_PER_MONTH_DEEP_USER = null; // Unlimited
// Study Snapshot and Consensus Snapshot credits
export const SNAPSHOT_CREDITS_PER_MONTH_ANONYMOUS_USER = 1;
export const SNAPSHOT_CREDITS_PER_MONTH_FREE_USER = 10;

// Force reset dates for pricing changes or other events
// Add dates here when you need all users to get a credit reset
// Format: ISO date strings (YYYY-MM-DD)
export const CREDIT_FORCE_RESET_DATES = [
  "2025-09-01", // Deep tier launch - credit limits adjusted
  // Add future dates as needed, for example:
  // "2025-10-01", // Even deeper tier - credit limits adjusted
  // "2026-01-01", // Purchased by Google for $1B so we can make the product free
];

// Server side only
export const META_ACCESS_TOKEN = process.env.META_ACCESS_TOKEN;
export const NEXTJS_LOG_LEVEL = process.env.NEXTJS_LOG_LEVEL;

// Languages
export const DEFAULT_LANG = "en";

// Thread
export const THREAD_TITLE_MAX_LENGTH = 100;
export const THREAD_TITLE_MIN_LENGTH = 1;
